import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';
import { classNames } from '@uds/typography';

const root = css`
  text-align: center;
`;

const stars = css`
  height: ${cssTheme.gu3};
  display: flex;
  justify-content: center;
  margin-bottom: ${cssTheme.gu2};
`;

const excerpt = css`
  font-style: normal;
`;

const textContainer = css`
  margin: 0;
  padding: 0;
`;
export default () => {
  return {
    root,
    stars,
    excerpt,
    textContainer: cx(classNames.content, textContainer),
  };
};
